export const contentFilters = {
  searchAfter: {
    filterName: "Search After",
    defaultValue: null,
  },
  verifiedProfiles: {
    filterName: "Verified Profiles",
    defaultValue: "",
  },
  contentType: {
    filterName: "Content Type",
    defaultValue: "",
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  searchType: {
    filterName: "Search Type",
    defaultValue: "content_uuid",
    valueMap: {
      content_uuid: "Content UUID",
      created_by: "User UUID",
      title: "Title",
      tag: "Tag",
      created_day: "Created Day",
      reject_reason: "Reject Reason",
      target_category: "Approve Reason",
      target_category_v2: "Target Category",
      reprocessed_moderation: "ReProcessed Moderation Level",
    },
  },
  audioId: {
    filterName: "Audio ID",
    defaultValue: "",
  },
  clusteredAudioId: {
    filterName: "Clustered Audio ID",
    defaultValue: "",
  },
  moderationLevel: {
    filterName: "Moderation Level",
    defaultValue: "",
    valueMap: {
      "": "All",
      3: "Auto Approved",
      0: "Auto Disabled",
      2: "Human Approved",
      "-1": "Human Disabled",
      1: "Unmoderated",
    },
  },
  rangeSearchType: {
    filterName: "Range Search Type",
    defaultValue: null,
    valueMap: {
      review_bucket: "Bucket",
      download_count: "Download Count",
      like_count: "Like Count",
      share_count: "Share Count",
      view_count: "View Count",
      video_duration: "Video Duration",
      "taxonomy_meta.video_quality_attributes.rating": "Taxonomy Rating",
    },
  },
  opSearchType: {
    filterName: "Range Search Operator",
    defaultValue: null,
    valueMap: {
      bt: "Between",
      eq: "Equal to",
      gt: "Greater Than",
      lt: "Less Than",
    },
  },
  rangeSearchText: {
    filterName: "Range Search Text",
    defaultValue: null,
  },
  rangeSearchFrom: {
    filterName: "Range Search From",
    defaultValue: null,
  },
  rangeSearchTo: {
    filterName: "Range Search To",
    defaultValue: null,
  },
  createdDateFrom: {
    filterName: "Created Date From",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created Date To",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "created_date",
    valueMap: {
      created_date: "Created Date",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
  sourceType: {
    filterName: "Source Type",
    defaultValue: "non_ads",
    valueMap: {
      "": "All Content",
      ads: "Ads Content",
      non_ads: "Non Ads Content",
    },
  },
  includeLang: {
    filterName: "Include Languages",
    defaultValue: "",
    valueMap: {
      all: "All",
      bn: "Bangala",
      bh: "Bhojpuri",
      en: "English",
      gu: "Gujarati",
      kn: "Kannada",
      hi: "Hindi",
      mr: "Marathi",
      ml: "Malayalam",
      or: "Odiya",
      pa: "Punjabi",
      ta: "Tamil",
      te: "Telugu",
    },
  },
  excludeLang: {
    filterName: "Exclude Languages",
    defaultValue: "",
    valueMap: {
      all: "All",
      bn: "Bangala",
      bh: "Bhojpuri",
      en: "English",
      gu: "Gujarati",
      kn: "Kannada",
      hi: "Hindi",
      mr: "Marathi",
      ml: "Malayalam",
      or: "Odiya",
      pa: "Punjabi",
      ta: "Tamil",
      te: "Telugu",
    },
  },
  bucket: {
    filterName: "Bucket",
    defaultValue: "-1",
  },
  maskedContent: {
    filterName: "Masked Content",
    defaultValue: "",
  },
  taggedContent: {
    filterName: "Tagged Content",
    defaultValue: "",
    valueMap: {
      Y: "Yes",
      N: "No",
    },
  },
  trendingContent: {
    filterName: "Trending Content",
    defaultValue: "",
    valueMap: {
      Y: "Yes",
      N: "No",
    },
  },
  isAssetUsed: {
    filterName: "Asset Used",
    defaultValue: "",
    valueMap: {
      true: "Yes",
      false: "No",
    },
  },
  videoSource: {
    filterName: "Video Source",
    defaultValue: "",
  },
  qcDone: {
    filterName: "QC Done",
    defaultValue: "",
  },
  shoppableContent: {
    filterName: "Shoppable Content",
    defaultValue: "",
    valueMap: {
      Y: "Yes",
      N: "No",
    },
  },
  reviewDone: {
    filterName: "Review Done",
    defaultValue: "",
  },
  rating: {
    filterName: "Rating",
    defaultValue: "",
  },
  trendingEntityId: {
    filterName: "Trending Entity Id",
    defaultValue: "",
  },
  pageSize: {
    filterName: "Page Size",
    defaultValue: 10,
  },
}

export const taxonomyFilters = {
  contentUUID: {
    filterName: "Content ID",
    defaultValue: null,
  },
  deskType: {
    filterName: "Desk Type",
    defaultValue: "",
    valueMap: {
      LANGUAGE_DESK: "Language Desk",
      QC_DESK: "QC Desk",
      INTERNAL_QC_DESK: "Internal QC Desk",
    },
  },
  moderationLevel: {
    filterName: "Moderation Level",
    defaultValue: "",
    valueMap: {
      "": "All",
      3: "Auto Approved",
      0: "Auto Disabled",
      2: "Human Approved",
      "-1": "Human Disabled",
      1: "Unmoderated",
    },
  },
  rangeSearchType: {
    filterName: "Range Search Type",
    defaultValue: null,
    valueMap: {
      review_bucket: "Bucket",
      download_count: "Download Count",
      like_count: "Like Count",
      share_count: "Share Count",
      view_count: "View Count",
      video_duration: "Video Duration",
      "taxonomy_meta.video_quality_attributes.rating": "Taxonomy Rating",
    },
  },
  opSearchType: {
    filterName: "Range Search Operator",
    defaultValue: null,
    valueMap: {
      bt: "Between",
      eq: "Equal to",
      gt: "Greater Than",
      lt: "Less Than",
    },
  },
  rangeSearchText: {
    filterName: "Range Search Text",
    defaultValue: null,
  },
  rangeSearchFrom: {
    filterName: "Range Search From",
    defaultValue: null,
  },
  rangeSearchTo: {
    filterName: "Range Search To",
    defaultValue: null,
  },
  createdDateFrom: {
    filterName: "Created Date From",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created Date To",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "view_count",
    valueMap: {
      view_count: "View Count",
      share_count: "Share Count",
      download_count: "Download Count",
      like_count: "Like Count",
      created_date: "Created Date",
      t_score_v2: "T Score V2",
      qc_order: "QC Order",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
  sourceType: {
    filterName: "Source Type",
    defaultValue: "non_ads",
    valueMap: {
      "": "All Content",
      ads: "Ads Content",
      non_ads: "Non Ads Content",
    },
  },
  langCode: {
    filterName: "Language",
    defaultValue: "",
    valueMap: {
      bn: "Bangala",
      bh: "Bhojpuri",
      en: "English",
      gu: "Gujarati",
      kn: "Kannada",
      hi: "Hindi",
      mr: "Marathi",
      ml: "Malayalam",
      or: "Odiya",
      pa: "Punjabi",
      ta: "Tamil",
      te: "Telugu",
    },
  },
  bucket: {
    filterName: "Bucket",
    defaultValue: "-1",
  },
  maskedContent: {
    filterName: "Masked Content",
    defaultValue: "",
  },
  taggedContent: {
    filterName: "Tagged Content",
    defaultValue: "",
    valueMap: {
      Y: "Yes",
      N: "No",
    },
  },
  trendingContent: {
    filterName: "Trending Content",
    defaultValue: "",
    valueMap: {
      Y: "Yes",
      N: "No",
    },
  },
  isAssetUsed: {
    filterName: "Asset Used",
    defaultValue: "",
    valueMap: {
      true: "Yes",
      false: "No",
    },
  },
  videoSource: {
    filterName: "Video Source",
    defaultValue: "",
  },
  qcDone: {
    filterName: "QC Done",
    defaultValue: "",
  },
  shoppableContent: {
    filterName: "Shoppable Content",
    defaultValue: "",
    valueMap: {
      Y: "Yes",
      N: "No",
    },
  },
  reviewDone: {
    filterName: "Review Done",
    defaultValue: "",
  },
  rating: {
    filterName: "Rating",
    defaultValue: "",
  },
  trendingEntityId: {
    filterName: "Trending Entity Id",
    defaultValue: "",
  },
  pageSize: {
    filterName: "Page Size",
    defaultValue: 10,
  },
}

export const userContentFilters = {
  moderationLevel: {
    filterName: "Moderation Level",
    defaultValue: "",
    valueMap: {
      "": "All",
      3: "Auto Approved",
      0: "Auto Disabled",
      2: "Human Approved",
      "-1": "Human Disabled",
      1: "Unmoderated",
    },
  },
  searchType: {
    filterName: "Search Type",
    defaultValue: "content_uuid",
    valueMap: {
      content_uuid: "Content UUID",
      created_by: "User UUID",
      title: "Title",
      tag: "Tag",
      created_day: "Created Day",
      reject_reason: "Reject Reason",
      target_category: "Approve Reason",
      target_category_v2: "Target Category",
      reprocessed_moderation: "ReProcessed Moderation Level",
    },
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "view_count",
    valueMap: {
      view_count: "View Count",
      share_count: "Share Count",
      download_count: "Download Count",
      like_count: "Like Count",
      created_date: "Created Date",
      t_score_v2: "T Score V2",
      qc_order: "QC Order",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
  langCode: {
    filterName: "Language",
    defaultValue: "",
    valueMap: {
      bn: "Bangala",
      bh: "Bhojpuri",
      en: "English",
      gu: "Gujarati",
      kn: "Kannada",
      hi: "Hindi",
      mr: "Marathi",
      ml: "Malayalam",
      or: "Odiya",
      pa: "Punjabi",
      ta: "Tamil",
      te: "Telugu",
    },
  },
}

export const cmsUserFilters = {
  searchType: {
    filterName: "Search Type",
    defaultValue: "email",
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  userStatus: {
    filterName: "User Status",
    defaultValue: "",
  },
  agency: {
    filterName: "Agency",
    defaultValue: "",
  },
  jotUserType: {
    filterName: "User Type",
    defaultValue: "",
  },
  permissions: {
    filterName: "Permissions",
    defaultValue: "",
  },
}

export const issueListFilter = {
  issueId: {
    filterName: "Issue Id",
    defaultValue: "",
  },
  userUuid: {
    filterName: "User Uuid",
    defaultValue: "",
  },
  contentUuid: {
    filterName: "Content Uuid",
    defaultValue: "",
  },
  status: {
    filterName: "Issue Status",
    defaultValue: "",
  },
  issueSeverity: {
    filterName: "Issue Severity",
    defaultValue: "",
  },
  reportedBy: {
    filterName: "Reported By",
    defaultValue: "",
  },
  assignedTo: {
    filterName: "Assigned To",
    defaultValue: "",
  },
  createdDateFrom: {
    filterName: "Created On",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created On",
    defaultValue: null,
  },
  modifiedDateFrom: {
    filterName: "Modified On",
    defaultValue: null,
  },
  modifiedDateTo: {
    filterName: "Modified On",
    defaultValue: null,
  },
  title: {
    filterName: "Title",
    defaultValue: "",
  },
}

export const bulkFilters = {
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  searchType: {
    filterName: "Search Type",
    defaultValue: "uploadedBy",
  },
  status: {
    filterName: "Status",
    defaultValue: "",
  },
  createdDateFrom: {
    filterName: "Created Date From",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created Date To",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "updatedOn",
    valueMap: {
      updatedOn: "Updated On",
      createdOn: "Created On",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
}

export const discoveryPageFilters = {
  pageId: {
    filterName: "Page Id",
    defaultValue: "",
  },
  title: {
    filterName: "Title",
    defaultValue: "",
  },
  status: {
    filterName: "Status",
    defaultValue: "",
  },
  pageType: {
    filterName: "Page Type",
    defaultValue: "",
  },
}

export const cameraAssetFilters = {
  comboId: {
    filterName: "Combo Id",
    defaultValue: "",
  },
  title: {
    filterName: "Title",
    defaultValue: "",
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
}

export const audioFilters = {
  audioId: {
    filterName: "Audio Id",
    defaultValue: "",
  },
  clusteredAudioId: {
    filterName: "Clustered Audio ID",
    defaultValue: "",
  },
  categories: {
    filterName: "Categories",
    defaultValue: [],
  },
  languages: {
    filterName: "Language",
    defaultValue: [],
  },
  title: {
    filterName: "Title",
    defaultValue: "",
  },
  sponsored: {
    filterName: "Sponsored",
    defaultValue: "N",
  },
  artist: {
    filterName: "artist",
    defaultValue: "",
  },
}

export const commentFilters = {
  searchType: {
    filterName: "Search Type",
    defaultValue: "id",
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: null,
  },
  userStatus: {
    filterName: "User Status",
    defaultValue: "",
  },
  moderationLevel: {
    filterName: "Moderation Level",
    defaultValue: "",
  },
  moderationLevel: {
    filterName: "Moderation Level",
    defaultValue: "",
    valueMap: {
      "": "All",
      3: "Auto Approved",
      0: "Auto Disabled",
      2: "Human Approved",
      "-1": "Human Disabled",
      1: "Unmoderated",
    },
  },
  rangeSearchType: {
    filterName: "Range Search Type",
    defaultValue: null,
    valueMap: {
      review_bucket: "Bucket",
      download_count: "Download Count",
      like_count: "Like Count",
      share_count: "Share Count",
      view_count: "View Count",
      video_duration: "Video Duration",
    },
  },
  opSearchType: {
    filterName: "Range Search Operator",
    defaultValue: null,
    valueMap: {
      bt: "Between",
      eq: "Equal to",
      gt: "Greater Than",
      lt: "Less Than",
    },
  },
  rangeSearchText: {
    filterName: "Range Search Text",
    defaultValue: null,
  },
  rangeSearchFrom: {
    filterName: "Range Search From",
    defaultValue: null,
  },
  rangeSearchTo: {
    filterName: "Range Search To",
    defaultValue: null,
  },
  createdDateFrom: {
    filterName: "Created Date From",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created Date To",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "view_count",
    valueMap: {
      view_count: "View Count",
      share_count: "Share Count",
      download_count: "Download Count",
      like_count: "Like Count",
      created_date: "Created Date",
      t_score_v2: "T Score V2",
      qc_order: "QC Order",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
}

export const hashtagFilters = {
  name: {
    filterName: "Hashtag Name",
    defaultValue: "",
  },
}

export const entityFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
}

export const effectFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  type: {
    filterName: "Type",
    defaultValue: "",
  },
}

export const templateFilters = {
  templateId: {
    filterName: "Template ID",
    defaultValue: "",
  },
  label: {
    filterName: "Label",
    defaultValue: "",
  },
  category: {
    filterName: "Category",
    defaultValue: "",
  },
}

export const stickersForSearchAndSelectFilters = {
  mimeType: {
    filterName: "Mime Type",
    defaultValue: "animatedsticker",
  },
  isActive: {
    filterName: "Is Active",
    defaultValue: true,
  },
  name: {
    filterName: "Sticker Name",
    defaultValue: "",
  },
}

export const trendingFilters = {
  audioId: {
    filterName: "Audio Id",
    defaultValue: "",
  },
  status: {
    filterName: "Status",
    defaultValue: [],
  },
  hashtag: {
    filterName: "hashtag",
    defaultValue: [],
  },
  trendingEntityId: {
    filterName: "Entity Id",
    defaultValue: "",
  },
}

export const challengeFilters = {
  searchType: {
    filterName: "Search Type",
    defaultValue: "",
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  type: {
    filterName: "Type",
    defaultValue: "",
  },
  status: {
    filterName: "Status",
    defaultValue: "",
  },
  sponsored: {
    filterName: "Sponsered",
    defaultValue: "N",
  },
}

export const cameraAssetTemplateFilters = {
  label: {
    filterName: "Label",
    defaultValue: "",
  },
  isProcessed: {
    filterName: "Is Processed",
    defaultValue: "",
    valueMap: {
      true: "True",
      false: "False",
    },
  },
}

export const manageBannerFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  bannerId: {
    filterName: "Banner Id",
    defaultValue: "",
  },
}

export const manageChipsFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  chipsId: {
    filterName: "Chips Id",
    defaultValue: "",
  },
}

export const manageMusicArtistFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  artistId: {
    filterName: "Artist Id",
    defaultValue: "",
  },
}

export const manageMusicLabelFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  labelId: {
    filterName: "Label Id",
    defaultValue: "",
  },
}

export const manageMusicPlaylistFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  playListId: {
    filterName: "Playlist Id",
    defaultValue: "",
  },
}

export const manageNamedCollectionFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  collectionId: {
    filterName: "Collection Id",
    defaultValue: "",
  },
}

export const manageWebGamesFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  webGameId: {
    filterName: "Web-Game Id",
    defaultValue: "",
  },
}

export const manageWebviewBannerFilters = {
  name: {
    filterName: "Name",
    defaultValue: "",
  },
  bannerId: {
    filterName: "Banner Id",
    defaultValue: "",
  },
}

export const contestFilters = {
  searchType: {
    filterName: "Search Type",
    defaultValue: "",
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  type: {
    filterName: "Type",
    defaultValue: "",
    valueMap: {
      type1: "Contest",
      type2: "Contest With Only Categories",
      type3: "Contest With Only Sub Categories",
      type4: "Contest With Categories and Sub Categories",
    },
  },
  sponsored: {
    filterName: "Sponsered",
    defaultValue: "",
  },
}

export const roomFilters = {
  searchType: {
    filterName: "Search Type",
    defaultValue: "title",
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "featuredIndex",
    valueMap: {
      featuredIndex: "Featured Index",
      count: "count",
      startDateTime: "Start Time",
      endDateTime: "End Time",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
  // hashTags: {
  //   filterName: "Hash Tags",
  //   defaultValue: null,
  // },
}

export const activityFilters = {
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  action: {
    filterName: "Action",
    defaultValue: undefined,
    valueMap: {
      activate: "Activate",
      deactivate: "DeActivate",
      content_tag_target_category_v2: "Tag Category",
      tag_non_english: "Tag Non English",
      create_content: "Create Content",
      update_content: "Update Content",
      bulk_create_content: "Bulk Create Content",
      content_quality_check: "Quality Check Content",
      create_app_user: "Create App User",
      update_app_user: "Update App User",
      bulk_create_app_user: "Bulk Create App Users",
      tag_content: "Tag Content",
    },
  },
  searchType: {
    filterName: "Search Type",
    defaultValue: "uuid",
    valueMap: {
      uuid: "UUID",
      moderator: "moderator",
    },
  },
  createdDateFrom: {
    filterName: "From Date",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "To Date",
    defaultValue: null,
  },
}

export const userFilters = {
  searchAfter: {
    filterName: "Search After",
    defaultValue: null,
  },
  searchType: {
    filterName: "Search Type",
    defaultValue: "user_uuid",
    valueMap: {
      name: "Name",
      user_uuid: "User UUID",
      email: "Email",
      createdDay: "Created Day"
    },
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  creatorType: {
    filterName: "Creator Type",
    defaultValue: "",
  },
  rangeSearchType: {
    filterName: "Range Search Type",
    defaultValue: null,
    valueMap: {
      review_bucket: "Bucket",
      download_count: "Download Count",
      like_count: "Like Count",
      share_count: "Share Count",
      view_count: "View Count",
      video_duration: "Video Duration",
    },
  },
  opSearchType: {
    filterName: "Range Search Operator",
    defaultValue: null,
    valueMap: {
      bt: "Between",
      eq: "Equal to",
      gt: "Greater Than",
      lt: "Less Than",
    },
  },
  rangeSearchText: {
    filterName: "Range Search Text",
    defaultValue: null,
  },
  rangeSearchFrom: {
    filterName: "Range Search From",
    defaultValue: null,
  },
  rangeSearchTo: {
    filterName: "Range Search To",
    defaultValue: null,
  },
  createdDateFrom: {
    filterName: "Created Date From",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created Date To",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "created_date",
    valueMap: {
      created_date: "Created Date",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
  contentCreateLangs: {
    filterName: "Creation Language",
    defaultValue: "",
    valueMap: {
      bn: "Bangala",
      bh: "Bhojpuri",
      en: "English",
      gu: "Gujarati",
      kn: "Kannada",
      hi: "Hindi",
      mr: "Marathi",
      ml: "Malayalam",
      or: "Odiya",
      pa: "Punjabi",
      ta: "Tamil",
      te: "Telugu",
    },
  },
  userLangPrimary: {
    filterName: "Primay Language",
    defaultValue: "",
    valueMap: {
      bn: "Bangala",
      bh: "Bhojpuri",
      en: "English",
      gu: "Gujarati",
      kn: "Kannada",
      hi: "Hindi",
      mr: "Marathi",
      ml: "Malayalam",
      or: "Odiya",
      pa: "Punjabi",
      ta: "Tamil",
      te: "Telugu",
    },
  },
  category: {
    filterName: "Categories",
    defaultValue: "",
    valueMap: {
      Love: "love",
      Bhakti: "bhakti",
      "Dance & Music": "dance&music",
      "News & Information": "news&info",
      Sports: "sports",
      "Health & Fitness": "health&fitness",
      Food: "food",
      Motivation: "motivation",
      "DIY & Hacks": "diy&hacks",
      "Beauty & Fashion": "beauty&fashion",
      "Movies & Entertainment": "movies&entertainment",
      "Funny & Humour": "funny&humour",
      CCTV: "cctv",
      Travel: "travel",
      Glamour: "glamour",
    },
  },
}

export const roleFilters = {
  searchAfter: {
    filterName: "Search After",
    defaultValue: null,
  },
  searchType: {
    filterName: "Search Type",
    defaultValue: "role_id",
    valueMap: {
      role_id: "Role ID",
      role_name: "Role Name",
      role_code: "Role Code",
      created_by: "Created By(Email)",
    },
  },
  searchText: {
    filterName: "Search Text",
    defaultValue: "",
  },
  rangeSearchType: {
    filterName: "Range Search Type",
    defaultValue: null,
    valueMap: {
      review_bucket: "Bucket",
      download_count: "Download Count",
      like_count: "Like Count",
      share_count: "Share Count",
      view_count: "View Count",
      video_duration: "Video Duration",
    },
  },
  opSearchType: {
    filterName: "Range Search Operator",
    defaultValue: null,
    valueMap: {
      bt: "Between",
      eq: "Equal to",
      gt: "Greater Than",
      lt: "Less Than",
    },
  },
  rangeSearchText: {
    filterName: "Range Search Text",
    defaultValue: null,
  },
  rangeSearchFrom: {
    filterName: "Range Search From",
    defaultValue: null,
  },
  rangeSearchTo: {
    filterName: "Range Search To",
    defaultValue: null,
  },
  createdDateFrom: {
    filterName: "Created Date From",
    defaultValue: null,
  },
  createdDateTo: {
    filterName: "Created Date To",
    defaultValue: null,
  },
  orderByField: {
    filterName: "Order By",
    defaultValue: "created_date",
    valueMap: {
      created_date: "Created Date",
    },
  },
  order: {
    filterName: "Order",
    defaultValue: "desc",
    valueMap: {
      asc: "Ascending",
      desc: "Descending",
    },
  },
}

export const LANGUAGES = [
  { value: "bn", label: "Bangala" },
  { value: "bh", label: "Bhojpuri" },
  { value: "en", label: "English" },
  { value: "gu", label: "Gujarati" },
  { value: "kn", label: "Kannada" },
  { value: "hi", label: "Hindi" },
  { value: "mr", label: "Marathi" },
  { value: "ml", label: "Malayalam" },
  { value: "or", label: "Odiya" },
  { value: "pa", label: "Punjabi" },
  { value: "ta", label: "Tamil" },
  { value: "te", label: "Telugu" },
]

export const LANGUAGE_MAPPING = {
  bn: "Bangala",
  bh: "Bhojpuri",
  en: "English",
  gu: "Gujarati",
  kn: "Kannada",
  hi: "Hindi",
  mr: "Marathi",
  ml: "Malayalam",
  or: "Odiya",
  pa: "Punjabi",
  ta: "Tamil",
  te: "Telugu",
}

export const CATEGORIES = [
  { value: "Trending", label: "Trending" },
  { value: "Filmy", label: "Filmy" },
  { value: "Funny", label: "Funny" },
  { value: "Dialogues", label: "Dialogues" },
  { value: "BGM", label: "BGM" },
  { value: "Status", label: "Status" },
  { value: "Romantic", label: "Romantic" },
  { value: "SwagHai", label: "Swag Hai" },
  { value: "YesudasHits", label: "Yesudas Hits" },
  { value: "SingleSuperStars", label: "Single Superstars" },
  { value: "DBoss", label: "DBoss" },
  { value: "PrinceSK", label: "Prince SK" },
]

export const DISPLAY_PERSONA = [
  { value: "celebrity", label: "Celebrity" },
  { value: "foodie", label: "Foodie" },
  { value: "genius", label: "Genius" },
  { value: "khiladi", label: "Khiladi" },
  { value: "mentor", label: "Mentor" },
  { value: "performer", label: "Performer" },
  { value: "popular", label: "Popular" },
  { value: "styleicon", label: "Style Icon" },
  { value: "techguru", label: "Tech Guru" },
  { value: "traveller", label: "Traveller" },
]

export const TARGET_CATEGORY = [
  { label: "GLAMOUR", value: "glamour" },
  { label: "DANCE", value: "dance" },
  { label: "PRANK", value: "prank" },
  { label: "COOKING", value: "cooking" },
  { label: "BHAKTI", value: "bhakti" },
  { label: "MOTIVATIONAL", value: "motivational" },
  { label: "MUSIC", value: "music" },
  { label: "DIY & HACKS", value: "diy & hacks" },
  { label: "EDUCATION", value: "education" },
  { label: "SPORTS", value: "sports" },
  { label: "FITNESS", value: "fitness" },
  { label: "BEAUTY", value: "beauty" },
  { label: "HEALTH", value: "health" },
  { label: "MOVIES & ENTERTAINMENT", value: "movies & entertainment" },
]

export const DEACTIVATE_REASONS = [
  { label: "COMPETITOR LOGO", value: "competitor_logo" },
  { label: "JOSH LOGO", value: "josh_logo" },
  { label: "SMALL DURATION", value: "small_duration" },
  { label: "MASALA", value: "masala" },
  { label: "PORN", value: "porn" },
  { label: "BLURRED", value: "blurred" },
  { label: "BLOOD", value: "blood" },
  { label: "DEATH", value: "death" },
  { label: "ACCIDENT", value: "accident" },
  { label: "SUICIDE", value: "suicide" },
  { label: "ANTI NATIONAL", value: "anti_national" },
  { label: "ANTI RELIGION", value: "anti_religion" },
  { label: "MISC", value: "misc" },
  { label: "ANIMAL CRUELTY", value: "animal_cruelty" },
  { label: "CHILD NUDITY", value: "child_nudity" },
  { label: "ABUSIVE", value: "abusive" },
  { label: "VIOLENCE", value: "violence" },
  { label: "COPYRIGHT CONTENT", value: "copyright_content" },
]

export const TARGET_CATEGORY_V2 = [
  { label: "Love", value: "love" },
  { label: "Bhakti", value: "bhakti" },
  { label: "Dance & Music", value: "dance&music" },
  { label: "News & Information", value: "news&info" },
  { label: "Sports", value: "sports" },
  { label: "Health & Fitness", value: "health&fitness" },
  { label: "Food", value: "food" },
  { label: "Motivation", value: "motivation" },
  { label: "DIY & Hacks", value: "diy&hacks" },
  { label: "Beauty & Fashion", value: "beauty&fashion" },
  { label: "Movies & Entertainment", value: "movies&entertainment" },
  { label: "Funny & Humour", value: "funny&humour" },
  { label: "CCTV", value: "cctv" },
  { label: "Travel", value: "travel" },
  { label: "Glamour", value: "glamour" },
]

export const MODERATION_REASONS = [
  { value: "ABUSIVE", label: "Abusive" },
  { value: "ADULT", label: "Adult" },
  { value: "BAD_QUALITY", label: "Bad Quality" },
  { value: "BIASED", label: "Biased" },
  { value: "COPYRIGHT", label: "Copyright" },
  { value: "FAKE", label: "Fake" },
  { value: "INCOMPLETE", label: "Incomplete" },
  { value: "NOT_READABLE", label: "Not Readable" },
  { value: "SPAM", label: "Spam Words" },
  { value: "VULGAR", label: "Vulgar" },
]

export const CURATED_TYPES = [
  { label: "Macro", value: "m" },
  { label: "UGC", value: "u" },
  { label: "Nano", value: "n" },
  { label: "Community", value: "c" },
  { label: "Kol", value: "k" },
  { label: "OGC", value: "o" },
  { label: "Celebrity/Stars", value: "s" },
  { label: "Micro", value: "l" },
  { label: "Internal", value: "i" },
  { label: "Ghost", value: "g" },
  { label: "Internal Brand", value: "ib" },
  { label: "External Brand", value: "eb" },
]

export const CURATED_GENRE_LIST = [
  { label: "Lip Sync", value: "lip_sync" },
  { label: "Mixed", value: "mixed" },
  { label: "Status", value: "status" },
  { label: "Skit", value: "skit" },
  { label: "Dancing", value: "dancing" },
  { label: "Music", value: "music" },
  { label: "Beauty Fashion", value: "beauty_fashion" },
  { label: "Fitness", value: "fitness" },
  { label: "Poetry", value: "poetry" },
  { label: "Food", value: "food" },
  { label: "Artist", value: "artist" },
  { label: "Devotional", value: "devotional" },
  { label: "Meme", value: "meme" },
  { label: "Travel", value: "travel" },
  { label: "News", value: "news" },
  { label: "Gaming", value: "gaming" },
  { label: "Diy", value: "diy" },
  { label: "Education", value: "education" },
  { label: "Vlogging", value: "vlogging" },
  { label: "NSFW", value: "nsfw" },
  { label: "Educational", value: "educational" },
  { label: "Stunts", value: "stunts" },
  { label: "Brand", value: "brand" },
  { label: "Vulgar", value: "vulgar" },
  { label: "Random", value: "random" },
  { label: "Erotic", value: "erotic" },
  { label: "Sports", value: "sports" },
  { label: "Glamorous", value: "glamorous" },
  { label: "Hot", value: "hot" },
  { label: "Entertainment", value: "entertainment" },
  { label: "Comedy", value: "comedy" },
  { label: "Photography", value: "photography" },
  { label: "Motivational", value: "motivational" },
  { label: "Automobile", value: "automobile" },
  { label: "Pets/Animals", value: "pets_and_animals" },
  { label: "NGO/Gov", value: "ngo_gov" },
]

export const CURATED_GENRE_LIST_MAPPING = {
  lip_sync: "Lip Sync",
  mixed: "Mixed",
  status: "Status",
  skit: "Skit",
  dancing: "Dancing",
  music: "Music",
  beauty_fashion: "Beauty Fashion",
  fitness: "Fitness",
  poetry: "Poetry",
  food: "Food",
  artist: "Artist",
  devotional: "Devotional",
  meme: "Meme",
  travel: "Travel",
  news: "News",
  gaming: "Gaming",
  diy: "Diy",
  education: "Education",
  vlogging: "Vlogging",
  nsfw: "NSFW",
  educational: "Educational",
  stunts: "Stunts",
  brand: "Brand",
  vulgar: "Vulgar",
  random: "Random",
  erotic: "Erotic",
  sports: "Sports",
  glamorous: "Glamorous",
  hot: "Hot",
}

export const CURATED_TYPE_MAPPING = {
  m: "Macro",
  u: "UGC",
  n: "Nano",
  c: "Community",
  k: "Kol",
  o: "OGC",
  s: "Celebrity/Stars",
  l: "Micro",
  i: "Internal",
  g: "Ghost",
  ib: "Internal Brand",
  eb: "External Brand",
}
export const ISSUE_ACTIVITY_MAPPING = {
  issueId: "Issue Id",
  summary: "Summary",
  phoneMake: "Phone Make",
  phoneModel: "Phone Model",
  clientId: "Client Id",
  supportingAssets: "Files",
  pocList: "Poc List",
  osVersion: "OS Version",
  appVersion: "App version",
  contentUuid: "Content Id",
  userUuid: "User Id",
  issueType: "Issue Type",
  issueSeverity: "Issue Severity",
  status: "Status",
  reportedBy: "Reported By",
  createdOn: "Created On",
  modifiedOn: "Modified On",
  assignedTo: "Assigned To",
  title: "Title",
  comment: "Comment",
  supportingAssets: "Attachments",
}

export const USER_TYPE_MAPPING = {
  i: "Internal",
  g: "Ghost",
  ib: "Internal Brand",
  eb: "External Brand",
  e: "External",
}

export const PERMISSIONS_ARRAY = [
  // this array doesn't contain all the permissions. Need to check and update
  { label: "Edit Browse Content", value: "EDIT_BROWSE_CONTENT" },
  { label: "View Browse Content", value: "VIEW_BROWSE_CONTENT" },
  { label: "View Manage Content", value: "VIEW_MANAGE_CONTENT" },
  { label: "Edit Manage Content", value: "EDIT_MANAGE_CONTENT" },
  { label: "Edit Boost Content", value: "VIEW_BOOST_CONTENT" },
  { label: "View Boost Content", value: "EDIT_BOOST_CONTENT" },
  { label: "Edit Dashboard", value: "EDIT_DASHBOARD" },
  { label: "Edit Community Management", value: "EDIT_COMMUNITY_MANAGEMENT" },
  { label: "Edit Browse Comment", value: "EDIT_BROWSE_COMMENT" },
  { label: "Edit Manage Comment", value: "EDIT_MANAGE_COMMENT" },
  { label: "Edit Manage Trending", value: "EDIT_MANAGE_TRENDING" },
  { label: "Edit Tag Trending", value: "EDIT_TAG_TRENDING" },
  { label: "View Tag Trending", value: "VIEW_TAG_TRENDING" },
  { label: "Edit Manage Campaign", value: "EDIT_MANAGE_CAMPAIGN" },
  { label: "Edit Browse Room", value: "EDIT_BROWSE_ROOM" },
  { label: "Edit Browse Hashtag", value: "EDIT_BROWSE_HASHTAG" },
  { label: "Edit Browse User", value: "EDIT_BROWSE_USER" },
  { label: "View User Details", value: "VIEW_USER_DETAILS" },
  { label: "Edit User Details", value: "EDIT_USER_DETAILS" },
  { label: "Edit Update Delta History", value: "EDIT_USER_DELTA_HISTORY" },
  { label: "Edit Boost Follow History", value: "EDIT_BOOST_FOLLOW_HISTORY" },
  { label: "Edit Boost Follow Meta/Status", value: "EDIT_BOOST_FOLLOW_META" },
  { label: "Edit Browse Brand", value: "EDIT_BROWSE_BRAND" },
  { label: "Edit Browse Challenge", value: "EDIT_BROWSE_CHALLENGE" },
  { label: "View Browse Challenge", value: "VIEW_BROWSE_CHALLENGE" },
  { label: "Edit Manage Challenge", value: "EDIT_MANAGE_CHALLENGE" },
  { label: "View Manage Challenge", value: "VIEW_MANAGE_CHALLENGE" },
  { label: "View Browse Contest", value: "VIEW_BROWSE_CONTEST" },
  { label: "View Manage Contest", value: "VIEW_MANAGE_CONTEST" },
  { label: "Edit Browse Contest", value: "EDIT_BROWSE_CONTEST" },
  { label: "Edit Manage Contest", value: "EDIT_MANAGE_CONTEST" },
  { label: "View Manage Audio", value: "VIEW_MANAGE_AUDIO" },
  { label: "Edit Manage Audio", value: "EDIT_MANAGE_AUDIO" },
  { label: "Edit Manage Camera Assets", value: "EDIT_MANAGE_CAMERA_ASSETS" },
  {
    label: "Edit Manage Category Assets",
    value: "EDIT_MANAGE_CATEGORY_ASSETS",
  },
  { label: "Edit Templates", value: "EDIT_TEMPLATES" },
  { label: "Edit Manage Sticker Assets", value: "EDIT_MANAGE_STICKER_ASSETS" },
  {
    label: "Edit Manage Sticker Subtype",
    value: "EDIT_MANAGE_STICKER_SUBTYPE",
  },
  { label: "Edit Manage Stickers", value: "EDIT_MANAGE_STICKERS" },
  { label: "View Manage Sticker Assets", value: "VIEW_MANAGE_STICKER_ASSETS" },
  {
    label: "View Manage Sticker Subtype",
    value: "VIEW_MANAGE_STICKER_SUBTYPE",
  },
  { label: "View Manage Stickers", value: "VIEW_MANAGE_STICKERS" },
  { label: "Edit Banners", value: "EDIT_BANNERS" },
  { label: "Edit Chips", value: "EDIT_CHIPS" },
  { label: "Edit Music Artist", value: "EDIT_MUSIC_ARTIST" },
  { label: "Edit Music Label", value: "EDIT_MUSIC_LABEL" },
  { label: "Edit Music Playlist", value: "EDIT_MUSIC_PLAYLIST" },
  { label: "Edit Named Collection", value: "EDIT_NAMED_COLLECTION" },
  { label: "Edit Web Games", value: "EDIT_WEB_GAMES" },
  { label: "Edit Web View Banners", value: "EDIT_WEB_VIEW_BANNERS" },
  { label: "Edit Browse Issue", value: "EDIT_BROWSE_ISSUE" },
  { label: "Edit Discovery Page", value: "EDIT_DISCOVERY_PAGE" },
  {
    label: "Edit Manage Collection Entities",
    value: "EDIT_MANAGE_COLLECTION_ENTITIES",
  },
  { label: "Edit Manage CMS User", value: "EDIT_MANAGE_CMS_USER" },
  { label: "Edit Manage Source", value: "EDIT_MANAGE_SOURCE" },
  { label: "Edit View Activity", value: "EDIT_VIEW_ACTIVITY" },
  { label: "Edit Bulk Upload Report", value: "EDIT_BULK_UPLOAD_REPORT" },
  { label: "Edit Boost Report", value: "EDIT_BOOST_REPORT" },
  { label: "Tag Content", value: "TAG_CONTENT" },
  { label: "View Activity", value: "VIEW_ACTIVITY" },
  { label: "Moderator Admin", value: "MODERATOR_ADMIN" },
  { label: "QC Tag Content", value: "QC_TAG_CONTENT" },
  { label: "Internal QC Tag Content", value: "INTERNAL_QC_TAG_CONTENT" },
  { label: "Review Ghost Content", value: "REVIEW_GHOST_CONTENT" },
  { label: "Tag Trending", value: "TAG_TRENDING" },
  { label: "Label Content", value: "LABEL_CONTENT" },
  { label: "Issue Admin", value: "ISSUE_ADMIN" },
  { label: "Issue User", value: "ISSUE_USER" },
  { label: "Edit Manage Event", value: "EDIT_MANAGE_EVENT" },
  { label: "View Manage Event", value: "VIEW_MANAGE_EVENT" },
  { label: "Update User Agency", value: "UPDATE_USER_AGENCY" },
  { label: "Hide Dashboard", value: "HIDE_DASHBOARD" },
  { label: "Edit CMS Video Asset", value: "EDIT_CMS_VIDEO_ASSET" },
  { label: "View CMS Video Asset", value: "VIEW_CMS_VIDEO_ASSET" },
  { label: "Edit CMS Video Template", value: "EDIT_CMS_VIDEO_TEMPLATE" },
  { label: "View CMS Video Template", value: "VIEW_CMS_VIDEO_TEMPLATE" },
  { label: "View Taxonomy Dashboard", value: "VIEW_TAXONOMY_DASHBOARD" },
]

export const COMPETITION_LOGO = {
  Roposo: "roposo",
  Vmate: "vmate",
  ShareChat: "sharechat",
  Chingari: "chingari",
  Mitron: "mitron",
  "Vigo Video": "vigo_video",
  "Tangi App": "tangi_app",
  Triller: "triller",
  Firework: "firework",
  Kwai: "kwai",
  HiPi: "hipi",
  "Moj (Sharechat)": "moj_sharechat",
  Zili: "zili",
  "MX Taka tak": "mx_taka_tak",
  Changa: "changa",
  LITLOT: "litlot",
  Chilli5: "chilli5",
  Welike: "welike",
  Madlipz: "madlipz",
  kindda: "kindda",
  Injoy: "injoy",
  kadak: "kadak",
  BIPTOK: "biptok",
  BRILLA: "brilla",
  ALAP: "alap",
  MOBISTAR: "mobistar",
  SHARARA: "sharara",
  ZOOMERANG: "zoomerang",
  "V SHORTS": "v_shorts",
  VSHOTS: "vshots",
  VSKIT: "vskit",
  RIZZLE: "rizzle",
  INDITOK: "inditok",
  SPLASH: "splash",
  ZAPAK: "zapak",
  "Ticklick app": "ticklick_app",
  MiqTok: "miqtok",
  "4Fun": "4fun",
  "TIK TOK": "tik_tok",
  "snack video": "snack_video",
  HELO: "helo",
  "INSTA REELS": "insta_reels",
  DUBSMASH: "dubsmash",
  LIKEE: "likee",
  Tiki: "tiki",
  InShot: "inshot",
}

export const collectionElements = {
  CREATOR: [{ label: "Video", value: "VIDEO" }],
  BANNER: [{ label: "Video", value: "VIDEO" }],
  CONTEST: [{ label: "Video", value: "VIDEO" }],
  HASHTAG: [{ label: "Video", value: "VIDEO" }],
  CHALLENGE: [{ label: "Video", value: "VIDEO" }],
  MUSIC_ARTIST: [{ label: "Music", value: "MUSIC" }],
  MUSIC_PLAYLIST: [{ label: "Music", value: "MUSIC" }],
  MUSIC_LABEL: [{ label: "Music", value: "MUSIC" }],
  STICKER: [{ label: "Video", value: "VIDEO" }],
  EFFECT: [{ label: "Video", value: "VIDEO" }],
  TEMPLATE: [{ label: "Video", value: "VIDEO" }],
  GAME: [{ label: "Video", value: "VIDEO" }],
  MUSIC: [{ label: "Video", value: "VIDEO" }],
  NAMED_COLLECTION: [
    { label: "Video", value: "VIDEO" },
    { label: "Music", value: "MUSIC" },
    { label: "Chip", value: "CHIP" },
    { label: "Creator", value: "CREATOR" },
    { label: "Banner", value: "BANNER" },
    { label: "Sub Banner", value: "SUBBANNER" },
    { label: "Video Banner", value: "VIDEO_BANNER" },
    { label: "Music Artist", value: "MUSIC_ARTIST" },
    { label: "Music Playlist", value: "MUSIC_PLAYLIST" },
    { label: "Music Label", value: "MUSIC_LABEL" },
    { label: "Sticker", value: "STICKER" },
    { label: "Effect", value: "EFFECT" },
    { label: "Template", value: "TEMPLATE" },
    { label: "Game", value: "GAME" },
    { label: "Web View Banner", value: "WEBVIEW_BANNER" },
  ],
}

export const COLLECTION_TO_LAYOUT_MAP = {
  VIDEO: [
    { label: "Type 2", value: "LAYOUT_TYPE_2" }, // y
  ],
  STICKER: [
    { label: "Type 2", value: "LAYOUT_TYPE_2" }, // y
  ],
  EFFECT: [
    { label: "Type 2", value: "LAYOUT_TYPE_2" }, // y
  ],
  TEMPLATE: [
    { label: "Type 2", value: "LAYOUT_TYPE_2" }, // y
  ],
  MUSIC: [
    { label: "Type 5", value: "LAYOUT_TYPE_5" }, // y
    { label: "Type 8", value: "LAYOUT_TYPE_8" },
  ],
  CHIP: [
    { label: "Type 11", value: "LAYOUT_TYPE_11" }, // y
    { label: "Type 12", value: "LAYOUT_TYPE_12" },
  ],
  WEBVIEW_BANNER: [
    { label: "Type 16", value: "LAYOUT_TYPE_16" }, // y
  ],
  CREATOR: [
    { label: "Type 3", value: "LAYOUT_TYPE_3" }, // y
  ],
  LIVE: [
    { label: "Type 17", value: "LAYOUT_TYPE_17" }, // y
  ],
  MUSIC_ARTIST: [
    { label: "Type 3", value: "LAYOUT_TYPE_3" }, //y
  ],
  MUSIC_PLAYLIST: [
    { label: "Type 6", value: "LAYOUT_TYPE_6" }, //y
  ],
  MUSIC_LABEL: [
    { label: "Type 4", value: "LAYOUT_TYPE_4" }, // y
  ],
  BANNER: [
    { label: "Type 1", value: "LAYOUT_TYPE_1" },
    { label: "Type 13", value: "LAYOUT_TYPE_13" },
  ],
  VIDEO_BANNER: [{ label: "Type 9", value: "LAYOUT_TYPE_9" }],
  GAME: [
    { label: "Type 5", value: "LAYOUT_TYPE_5" },
    { label: "Type 8", value: "LAYOUT_TYPE_8" },
    { label: "Type 14", value: "LAYOUT_TYPE_14" },
  ],
  COMMON: [{ label: "Type 15", value: "LAYOUT_TYPE_15" }],
  SUBBANNER: [{ label: "Type 7", value: "LAYOUT_TYPE_7" }],
}

export const USER_DEACTIVATE_REASONS = [
  { label: "Profile Image NSFW", value: "Profile_Image_NSFW" },
  { label: "Profile Name NSFW", value: "Profile_Name_NSFW" },
  { label: "Profile Handle NSFW", value: "Profile_Handle_NSFW" },
  { label: "Profile Description NSFW", value: "Profile_Description_NSFW" },
  { label: "Profile Content NSFW", value: "Profile_Content_NSFW" },
  { label: "Govt. Requested", value: "Govt_Requested" },
  { label: "Creator Requested", value: "Creator_Requested" },
  { label: "Copyright", value: "Copyright" },
  { label: "Account Manager Requested", value: "Account_Manager_Requested" },
  { label: "Impersonation", value: "Impersonation" },
  { label: "Abusive Comments", value: "Abusive_Comments" },
  { label: "Spam Comments", value: "Spam_Comments" },
]

export const SOURCES = [
  { label: "Reels", value: "REELS" },
  { label: "Moz", value: "MOZ" },
  { label: "Youtube Shorts", value: "YOUTUBE_SHORTS" },
  { label: "Yahoo", value: "YAHOO" },
  { label: "Twitter", value: "TWITTER" },
  { label: "Facebook", value: "FACEBOOK" },
]

export const EVENT_TYPES = [
  { label: "Date", value: "date" },
  { label: "Day", value: "day" },
  { label: "Part of Day", value: "part_of_day" },
  { label: "Religious Festivals", value: "religious_festivals" },
  { label: "National Festivals", value: "national_festivals" },
  { label: "Regional Festivals", value: "regional_festivals" },
  { label: "Celeb B'days", value: "celeb_bdays" },
  { label: "Election", value: "election" },
  { label: "Sports", value: "sports" },
  { label: "RIP", value: "rip" },
]

export const TEAM_TO_DL_MAP = {
  iOS: "creatorissues_ios@verse.in",
  Android: "creatorissues_android@verse.in",
  Moderation: "bismay.nayak@verse.in",
  PWA: "creatorissues_pwa@verse.in",
  Product: "creatorissues_product@verse.in",
}

export const ISSUE_TYPES = {
  LOGIN: {
    label: "Unable to login",
    priority: "high",
  },
  UPLOAD_VIDEO: {
    label: "Unable to upload a video",
    priority: "high",
  },
  CREATOR_HACKED: {
    label: "Creator account is hacked",
    priority: "high",
  },
  MODERATION_ERROR: {
    label: "Moderation error",
    priority: "moderate",
  },
  ACCOUNT_AUTHENTICATION: {
    label: "Request to change account authentication method",
    priority: "moderate",
  },
  LINK_SOCIAL_MEDIA: {
    label: "Unable to link social media",
    priority: "low",
  },
  VIDEO_NOT_APPEARING: {
    label: "Videos not appearing under profile",
    priority: "low",
  },
  FOREIGN_COUNTRY: {
    label: "Using app in foreign contry",
    priority: "low",
  },
  OTHER: {
    label: "Other",
    priority: "low",
  },
}

export const USER_TYPES = [
  {
    label: "Super Admin",
    value: 1,
    allow: [1],
  },
  {
    label: "Admin",
    value: 2,
    allow: [1],
  },
  { label: "Head of Community", value: 3, allow: [1, 2, 3] },
  { label: "Community Team Lead", value: 4 },
  { label: "Josh Manager", value: 5 },
  { label: "Community Account Manager", value: 6 },
  {
    label: "Audio Manager",
    value: 7,
  },
  {
    label: "Issue Manager",
    value: 8,
  },
  {
    label: "Operations Team",
    value: 9,
  },
  {
    label: "Operations Lead",
    value: 10,
  },
  {
    label: "Head of Operations",
    value: 11,
  },
  {
    label: "Ingestion Team",
    value: 12,
  },
  {
    label: "Discovery page managment",
    value: 13,
  },
  {
    label: "Challenge Managment",
    value: 14,
  },
  {
    label: "Promotions",
    value: 15,
  },
  {
    label: "Content Hygine",
    value: 16,
  },
  {
    label: "Notification Team",
    value: 17,
  },
  {
    label: "Customer Service",
    value: 18,
  },
  {
    label: "Moderation Internal",
    value: 19,
  },
  {
    label: "Moderation Agency",
    value: 20,
  },
  {
    label: "Labelling-Deck",
    value: 21,
  },
]

export const NO_PERMISSION_MESSAGE = `You don't have appropriate permission to perform this action`
export const ACTIONS_TO_NAME = {
  activate: "Activated",
  deactivate: "Deactivated",
  tag_content: "Tagged",
  skip_tag_content: "Skipped Tag",
  qc_tag_content_ok: "QC OKed",
  qc_tag_content_modify: "Modified the QC tag",
}

export const labelsForViolenceAndGlamour = {
  glamour: {
    non_glamour: "No Glamour",
    masala:
      "MASALA: 30-50% exposure, Sexually Suggestive,/Bikini Shoot w. high skin show,/CRINGY",
    vulgar_masala:
      "Vulgar MASALA: 50-70% exposure,Bare Hips/back, Love making with not much parts visible",
    masala_hot_sexy:
      "The woman is wearing VERY skimpy clothes, and the audio-visual seems to showcase very crude sexual movements or suggestiveness",
    glamorous:
      "The woman is wearing VERY skimpy clothes, but the audio-visual is classy (premium or international)",
    classy_hot_sexy:
      "The woman is wearing sexy clothes, with lots of skin visible, but is not making any sexually suggestive moves or actions",
    pretty_girl:
      "The woman is wearing pretty clothes, with low/ minimal skin show, and is mainly trying to look pretty",
    body_art:
      "Showcasing body art and tattoos where the focus is on the art; no sexual movements in the video; upper body nudity is allowed but not genitals",
    acceptable_child_nudity_a: "The focus is on nude child's cuteness",
    acceptable_child_nudity_b:
      "The focus is on partailly nude child's cuteness",
    partial_adult_nudity_a: "Strong artistic focus and only upper body nudity",
    partial_adult_nudity_b: "No artistic focus but no genitals visible",
    partial_adult_nudity_c:
      "Very transparent clothing over the breasts & genital area",
    partial_adult_nudity_d:
      "Non-transparent clothing, only barely covering the breasts & genital area",
    molestation:
      "A man sexually touching a woman without her permission; videos that seem to capture women in compromising positions/ nudity without their permission; hidden camera",
    unacceptable_child_nudity_a:
      "The focus is on nude child's sexuality/genitals",
    unacceptable_child_nudity_b:
      "The focus is on partailly nude child's sexuality/genitals",
    full_adult_nudity_a:
      "Full adult nudity, Strong artistic focus and only upper body nudity",
    full_adult_nudity_b: "No artistic focus but no genitals visible",
  },
  violence: {
    no_violence: "No Violence",
    legal_display_of_weapons: "Legal display of weapons in the video",
    animal_sports: "Animal being used for Sports (no killing or bloodshed)",
    physical_abuse: "Physical Abuse to Humans",
  },
}
export const tagTOLabel = {
  video_violence: "Video Violence",
  video_glamour: "Video Glamour",
  look_feel: "Look Feel",
  screen_coverage: "Screen Coverage",
  audio_vulgarity: "Audio Vulgarity",
  background_noise: "Background Noise",
  sound_quality: "Sound Quality",
  competition_logo: "Competition Logo",
  people_in_video: "People In Video",
  male_x_factor: "Male X Factor",
  taxonomy_language: "Taxonomy Language",
  taxonomy_video_format: "Taxonomy Video Format",
  taxonomy_emotions: "Taxonomy Emotions",
  target_theme: "Target Theme",
  video_quality_attributes: "Video Quality Attributes",
  target_languages: "Target Languages",
  taxonomy_genre: "Taxonomy Genre",
  orthogonal_attributes: "Orthogonal Attributes",
  ...labelsForViolenceAndGlamour.glamour,
  ...labelsForViolenceAndGlamour.violence,
  ...LANGUAGE_MAPPING,
  no_language: "No Language",
  "other_comedy_&_fun": "Other Comedy & Fun",
  adult: "Adult",
  movie_clipping: "Movie Clipping",
  song_clipping: "Song/Album Clipping",
  reality_tv_shows: "Reality TV Shows",
  tv_serial_clipping: "TV Serial Clipping",
  reviews: "Reviews",
  trailers: "Trailers",
  film_stars: "Film Stars",
  tv_stars: "Tv Stars",
  movie_clipping: "Movie Clipping",
  song_clipping: "Song/Album Clipping",
  reality_tv_shows: "Reality TV Shows",
  tv_serial_clipping: "TV Serial Clipping",
  reviews: "Reviews",
  trailers: "Trailers",
  gossip: "Gossip",
  film_stars: "Film Stars",
  tv_stars: "TV Stars",
  launch_events: "Launch Events",
  award_events: "Award Events",
  cartoon_shows_or_anime: "Cartoon shows or anime",
  other: "Other",
  entertainment_theme: "Theme",
  comedy_shows_standup: "Comedy Shows & Standup Comedians",
  roasts: "Roasts",
  adult_comedy: "Adult Comedy",
  memes: "Memes",
  other_comedy_fun: "Other Comedy & Fun",
  comedy_n_fun_type: "Comedy & Fun Type",
  kids: "Kids",
  family: "Family",
  couple: "Couple",
  sibling: "Sibling",
  friends: "Friends",
  adult: "Adult",
  "other_comedy_&_fun": "Other Comedy & Fun",
  comedy_n_fun_theme: "Comedy N Fun Theme",
  comedy_n_fun: "Comedy N Fun",
  animal_fails: "Animals fail",
  kids_fails: "Kids fail",
  adult_fail: "Adult fail",
  cctv_fails: "CCTV fails",
  stunt_fail: "Stunt Fail",
  random_fails: "Random fails",
  offbeat_hatke_fails: "Offbeat / Hatke fails",
  accident_disaster: "Accident & Disaster",
  unusual_things_horror_mysteries: "Unusual Things, Horror & Mysteries",
  other_fails: "Other fails",
  surprise_element: "Surprise Element",
  quality_talent: "Quality Talent",
  rating: "Rating",
  relatable: "Relatable",
  presentable: "Presentable",
  simple: "Simple",
  skip_reason: "Skip Reason",
  abusive: "ABUSIVE",
  accident: "ACCIDENT",
  animal_cruelty: "ANIMAL CRUELTY",
  anti_national: "ANTI NATIONAL",
  anti_religion: "ANTI RELIGION",
  blood: "BLOOD",
  blurred: "BLURRED",
  child_nudity: "CHILD NUDITY",
  competitor_logo: "COMPETITOR LOGO",
  death: "DEATH",
  josh_logo: "JOSH LOGO",
  masala: "MASALA",
  misc: "MISC",
  porn: "PORN",
  small_duration: "SMALL DURATION",
  suicide: "SUICIDE",
  violence: "VIOLENCE",
  entity_festival_groups: "Festival Groups",
  entity_festival_values: "Festival Name",
  target_type: "Taxonomy Genre",
  normal_camera_video: "Normal Camera Video - can be shot on mobile",
  camera_video_text_onscreen: "Camera Video with Text on Screen",
  special_effects_camera_video:
    "Special Effects Camera Video - not possible without editing",
  duet: "Duet - Two videos side by side, people interacting",
  reactions: "Reactions - Two videos, one reacting to another",
  slide_show: "Slide Show - one or more images joined together",
  animation_cartoons_digitalart: "Animation / Cartoons / Digital Art",
  clips_n_recordings: "Clips & Recordings",
  audio_language: "Audio Language",
  target_sub_type: "Taxonomy Genre",
  target_theme: "Taxonomy Genre",
  taxonomy_video_quality: "Glamour & Violence",
  taxonomy_elements: "Elements",
  city_tier: "City Tier",
}

export const emailListForNotifWorthyDeactivation = [
  "shahbaz.hasan@verse.in",
  "james.pj@eternoinfotech.com",
  "sharanajata.mishra@eternoinfotech.com",
  "ramjendra.dixit@verse.in",
  "yuvika.agrawal@verse.in",
  "bismay.nayak@verse.in",
  "dipta.pramanick@verse.in",
  "dheeraj.ram@verse.in",
  "debosmita.dey@verse.in",
  "joshnotify@eternoinfotech.com",
]

export const taxonomySideBarKeyValue = {
  skit_humanity: "Skit - Humanity",
  skit_romantic_heartbreak: "Skit - Romantic/Heart break",
  skit_family_love_respect: "Skit - Family love/Respect",
  skit_patriotic: "Skit - Patriotic",
  lipsync_romantic_heartbreak: "Lip Sync - Romantic/Heart break",
  lipsync_dialogue: "Lip Sync - Dialogue",
  movie_tv_ott_clips: "Movie/TV/OTT Clips",
  movie_tv_ott_celebs: "Movie/TV/OTT Celebs",
  video_selfie: "Video selfie",
  entertainment: "Entertainment",
  comedy_n_fun: "Comedy & Fun",
  fails: "Accidents & Fails",
  dance: "Dance",
  poetry_or_shayari: "Poetry or Shayari",
  pranks: "Pranks",
  stunts: "Stunts",
  status_wishes: "Status & Wishes",
  fun_party: "Fun & Party",
  food_cooking: "Food & Cooking",
  fitness_health: "Fitness & Health",
  beauty_fashion: "Beauty & Fashion",
  education: "Education",
  astrology: "Astrology",
  guru_speaks_motivational_spiritual_patriotic:
    "Guru Speaks - Motivational / Spiritual / Patriotic",
  gods_or_goddess: "Gods or Goddess",
  pets_wildlife_sealife: "Pets / Wildlife / Sealife",
  cars_bikes_aircrafts: "Cars, Bikes & Planes",
  gadgets: "Gadgets",
  toys: "Toys",
  arts_crafts: "Arts & Crafts",
  diy_hacks: "DIY & Hacks",
  photography: "Photography",
  sports: "Sports",
  cricket: "Cricket",
  football: "Football",
  magic_performance: "Magic Performance",
  architecture: "Architecture",
  travel: "Travel",
  news: "News",
  cant_identify_genre: "Can't Identify",
  romantic_heartbreak: "Romantic/Heart Break",
  family_love: "Family love",
  festivals: "Festivals",
  good_morning_wishes: "Good morning wishes",
  good_day_wishes: "Good day wishes",
  good_night_wishes: "Good night wishes",
  motivational: "Motivational",
  other_imp_days_national_days: "Other Imp Days - National days",
  devotional: "Devotional",
  patriotic: "Patriotic",
  image_selfie: "Image selfie",
  type_non_veg: "Is it Veg or Non Veg?",
  non_veg: "Non Veg",
  veg: "Veg",
  indoor: "Indoor",
  gym: "Gym",
  park: "Park",
  rooftop: "Rooftop",
  sky: "Sky",
  road_track: "Road / Track",
  fields_farms: "Fields / Farms",
  jungle: "Jungle",
  beach: "Beach",
  water_body: "Water Body",
  mountains: "Mountains",
  airport: "Airport",
  railway_station: "Railway Station",
  stadium: "Stadium",
  shopping_mall_market: "Shopping Mall / Market",
  hotel_restaurant: "Hotel/Restaurant",
  beautiful_architecture: "Beautiful Architecture",
  famous_architecture: "Famous Architecture",
  temple: "Temple",
  masjid_mosque: "Masjid (Mosque)",
  gurudwara: "Gurudwara",
  church: "Church",
  mixed: "Mixed",
  international: "International",
  rural: "Rural",
  cant_identify: "Can't Identify",
  unacceptable_child_nudity: "Unacceptable child nudity",
  "full_adult_nudity#b": "Full adult nudity",
  acceptable_child_nudity: "Acceptable child nudity",
  "partial_adult_nudity#c": "Partial adult nudity",
  "partial_adult_nudity#d": "Partial adult nudity",
  pretty_girl: "Pretty girl",
  glamorous: "Glamorous",
  classy_hot_sexy: "Classy hot sexy",
  masala: "Masala",
  vulgar_masala: "Vulgar masala",
  physical_abuse: "Physical abuse",
  animal_sports: "Animal Sports",
  legal_display_of_weapons: "Legal Display Of Weapons",
  all: "All",
  north: "North",
  south: "South",
  few: "Few",
  non_glamour: "No Glamour",
  hinduism: "Hinduism",
  islam: "Islam",
  sikhism: "Sikhism",
  christianity: "Christianity",
  jainism: "Jainism",
  buddhism: "Buddhism",
  other_religions: "Other Religions",
  brahma: "Brahma",
  vishnu: "Vishnu",
  shiva: "Shiva",
  laxmi: "Laxmi",
  saraswati: "Saraswati",
  ganesha: "Ganesha",
  krishna: "Krishna",
  ram: "Ram",
  hanuman: "Hanuman",
  durga: "Durga",
  kali: "Kali",
  other_gods: "Other gods",
  life_management: "Life management",
  relationship_tips: "Relationship tips",
  self_grooming: "Self Grooming",
  success_motivation: "Success series",
  money_motivation: "Money",
  good_manners: "Good manners",
  communication_skills: "Improving Communication Skills",
  patriotism: "Patriotism",
  social_contribution: "Contributing to society(Willingness to change world",
  zodiac_horoscope: "Raashi Bhavishya",
  business_horoscope: "Business/Shares/Stocks/Investments/Profit/Loss etc",
  relationship_horoscope: "Relationships",
  matrimonial_horoscope: "Matrimonial",
  career_horoscope: "Career/Jobs/Education",
  general_prediction: "General Prediction",
  nakshatra_based_horoscope: "Festivals/Nakshtra/Planetory Changes",
  others: "Others",
}
